import { Outlet } from 'react-router-dom';

import { PrimaryButton } from '../components/button/PrimaryButton';
import { SecondaryButton } from '../components/button/SecondaryButton';
import { Spinner } from '../components/Spinner';
import { useAuth } from '../hooks/useAuth';
import { useTokens } from '../hooks/useTokens';
import { t } from '../services/translation/translation';

export const ProtectedLayout = () => {
  const { tokens } = useTokens();
  const { logoutMutation } = useAuth();

  const handleLogout = () => {
    logoutMutation.mutate();
  };

  if (tokens === undefined) {
    return <Spinner />;
  }

  if (tokens) {
    return (
      <div className="pt-2 px-4 pb-4 flex flex-col md:justify-center m-auto gap-8 md:max-w-[368px] min-h-[calc(100vh-72px)]">
        <div className={'flex flex-col gap-1 items-start'}>
          <div className="flex flex-col gap-2">
            <h1
              className={
                'uppercase font-bold font-display  text-display-medium leading-lh-display-medium tracking-normal text-text-primary'
              }
            >
              {t('pwa.anonymous-protection.already-connecter')}
            </h1>
            <p className="text-body-lg leading-lh-body-lg text-text-secondary">
              {t('pwa.anonymous-protection.already-connected-description')}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <div className="flex-1">
            <SecondaryButton
              onClick={() => {
                window.location.href = '/';
              }}
            >
              {t('pwa.common.stay-connected')}
            </SecondaryButton>
          </div>
          <div className="flex-1">
            <PrimaryButton onClick={handleLogout}>{t('pwa.logout-modal.confirm')}</PrimaryButton>
          </div>
        </div>
      </div>
    );
  }

  return <Outlet />;
};
